function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

export function openModal(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  const sbw = getScrollbarWidth();
  document.documentElement.style.setProperty("--scrollbar-width", sbw + "px");

  modal.classList.add("is-modal-open");
  document.body.classList.add("is-modal-open");
  modal._previousFocus = document.activeElement;

  const close = modal.querySelector(".c-modal__close");
  if (close) close.focus();
}

export function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  modal.classList.remove("is-modal-open");
  document.body.classList.remove("is-modal-open");
  document.documentElement.style.removeProperty("--scrollbar-width");

  if (modal._previousFocus) {
    modal._previousFocus.focus();
    modal._previousFocus = null;
  }
}

function getOpenModal() {
  return document.querySelector(".c-modal.is-modal-open");
}

function trapFocus(modal, e) {
  const focusable = modal.querySelectorAll(
    'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
  );
  if (!focusable.length) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault();
    last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault();
    first.focus();
  }
}

export function initModal() {
  document.addEventListener("DOMContentLoaded", () => {
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest("[data-modal-open]");
      if (trigger) {
        e.preventDefault();
        openModal(trigger.dataset.modalOpen);
        return;
      }

      const closeBtn = e.target.closest(".c-modal__close");
      if (closeBtn) {
        const modal = closeBtn.closest(".c-modal");
        if (modal) closeModal(modal.id);
        return;
      }

      if (e.target.classList.contains("c-modal__overlay")) {
        const modal = e.target.closest(".c-modal");
        if (modal) closeModal(modal.id);
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const modal = getOpenModal();
        if (modal) closeModal(modal.id);
      }

      if (e.key === "Tab") {
        const modal = getOpenModal();
        if (modal) trapFocus(modal, e);
      }
    });
  });
}
